module.exports = {
  __init__: [ 'tooltips' ],
  tooltips: [ 'type', require(243) ]
};